import { render } from "./CamionParTypes.vue?vue&type=template&id=c332f056"
import script from "./CamionParTypes.vue?vue&type=script&lang=js"
export * from "./CamionParTypes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__